<script>
	import { currentUser } from '../stores/user.js';
</script>

<!-- <<h1 class="text-4xl">Welcome {#if $currentUser}{$currentUser.displayName}{/if}</h1> -->
<p>Welcome {#if $currentUser}{$currentUser.displayName}{/if}</p>